'use client';

import { RichTextMapSerializer, RichTextMapSerializerFunction } from '@prismicio/client/richtext';
import { PrismicRichText, PrismicRichTextProps } from '@prismicio/react';
import React, { ReactNode } from 'react';

import { Anchor } from '../../design-system/components/anchor/Anchor';

type EvaneosPrismicRichTextProps = PrismicRichTextProps;

const heading1: RichTextMapSerializer<ReactNode>['heading1'] = ({ children }) => {
    return <h1 className="font-secondary-m-bold">{children}</h1>;
};

const heading2: RichTextMapSerializer<ReactNode>['heading2'] = ({ children }) => {
    return <h2 className="font-l-extrabold">{children}</h2>;
};

const heading3: RichTextMapSerializer<ReactNode>['heading3'] = ({ children }) => {
    return <h3 className="font-m-extrabold">{children}</h3>;
};

const paragraph: RichTextMapSerializer<ReactNode>['paragraph'] = ({ children }) => {
    return <p className="font-body-regular">{children}</p>;
};

const removeHtmlTag: RichTextMapSerializerFunction<ReactNode> = ({ children }) => {
    return <>{children}</>;
};

const hyperlink: RichTextMapSerializer<ReactNode>['hyperlink'] = ({ node, children }) => {
    if (!node.data.url) {
        return <>{children}</>;
    }

    const target = node.data.link_type === 'Web' ? node.data.target : '_self';

    return (
        <Anchor target={target} href={node.data.url} rel="noopener">
            {children}
        </Anchor>
    );
};

export function EvaneosPrismicRichText(props: EvaneosPrismicRichTextProps) {
    const defaultComponents = {
        heading1,
        heading2,
        heading3,
        paragraph,
        hyperlink,
    };

    return <PrismicRichText {...props} components={props.components ?? defaultComponents} />;
}

EvaneosPrismicRichText.heading1 = heading1;
EvaneosPrismicRichText.heading2 = heading2;
EvaneosPrismicRichText.heading3 = heading3;
EvaneosPrismicRichText.paragraph = paragraph;
EvaneosPrismicRichText.hyperlink = hyperlink;
EvaneosPrismicRichText.removeHtmlTag = removeHtmlTag;
